


























































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbAlert, mdbProgress } from '@folky-tools/mdbvue';
import { usersService, axiosService } from '@/services';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionLogInfoGroup } from '@/models/users/user-logging/user-action-log-info-group';
import { VueGoodTable } from '@folky-tools/vue-good-table';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbAlert,
        mdbProgress,
        VueGoodTable,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class UserActionLogsListView extends Vue {
    private userActionLogsPerPage: number = 20;
    private rows: UserActionLogInfoGroup[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private isLoading: boolean = false;
    private serverParams: any = {
        columnFilters: {
            userEmail: ''
        },
        sort: [
            {
                field: 'dateLocal',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: this.userActionLogsPerPage
    };

    private async beforeMount(): Promise<void> {
        await this.setColumns();
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.users.userActionLogsListView.title');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.UserActionLogs,
                scope: UserActionScopeType.List
            })
        );
    }

    private async onPageChange(params: any): Promise<void> {
        this.serverParams.page = params.currentPage;
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        if (params[0].field !== this.serverParams.sort[0].field || params[0].type !== this.serverParams.sort[0].type) {
            this.serverParams.sort[0].field = params[0].field;
            this.serverParams.sort[0].type = params[0].type;
            await this.loadItems();
        }
    }

    private async onColumnFilter(params: any): Promise<void> {
        if (params.columnFilters.userEmail !== this.serverParams.columnFilters.userEmail) {
            this.serverParams.page = 1;
            this.serverParams.columnFilters.userEmail = params.columnFilters.userEmail;
            await this.loadItems();
        }
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.serverParams.perPage = params.currentPerPage;
        await this.loadItems();
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('users/organization/log-actions/query', {
            params: this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.item1;
        response.data.item2.forEach((item: any) => {
            return this.rows.push(new UserActionLogInfoGroup(item));
        });

        this.isLoading = false;
    }

    private getQueryParams(sortOrder: any, currentPage: number, perPage: number): any {
        return {
            skip: (currentPage - 1) * perPage,
            top: perPage,
            orderBy: this.getQueryOrderField(sortOrder),
            orderByDirection: this.getQueryOrderDirection(sortOrder),
            userEmailfilter: this.getUserEmailQueryFilter()
        };
    }

    private getQueryOrderField(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'dateLocal') {
                return 'dateUtc';
            } else {
                return sortOrder[0].field;
            }
        } else {
            return null;
        }
    }

    private getQueryOrderDirection(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            return sortOrder[0].type;
        } else {
            return null;
        }
    }

    private getUserEmailQueryFilter(): string | null {
        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'userEmail') {
                    return this.serverParams.columnFilters[key].replace('\'', '\'\'');
                }
            }
        }
        return null;
    }

    private setColumns(): void {
        this.columns = [
            { field: 'id', type: 'number', sortable: false },
            { field: 'dateLocal', type: 'text', sortable: true },
            { field: 'userId', type: 'number', sortable: false },
            {
                field: 'userEmail',
                type: 'text',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByEmail'),
                    filterValue: ''
                }
            },
            { field: 'action', type: 'text', sortable: false },
            { field: 'applicationCommercialName', type: 'text', sortable: false }
        ];
    }
}
